// client/src/components/teams/payloadToStats.ts
//
// Convierte stats_payload (almacenado en team_stats) de vuelta a DerivedStats.
// Necesario para el dashboard de coaching — permite renderizar stats completas
// de un jugador sin tener acceso a sus hand histories.

import { emptyStats } from '../../utils/pokerStats/emptyStats';
import { derivedStats } from '../../utils/pokerStats/derived';
import { DerivedStats } from '../../utils/pokerStats/types';

export function payloadToDerived(payload: Record<string, any> | null | undefined): DerivedStats | null {
  if (!payload || !(payload.vpip?.opp > 0)) return null;

  const s = emptyStats();

  s.handsPlayed = payload.vpip.opp;
  s.vpipCount   = payload.vpip.count    ?? 0;
  s.pfrCount    = payload.pfr?.count    ?? 0;

  s.threebetOpp   = payload.threebet?.opp   ?? 0;
  s.threebetCount = payload.threebet?.count ?? 0;

  s.foldTo3betOpp   = payload.foldTo3bet?.opp   ?? 0;
  s.foldTo3betCount = payload.foldTo3bet?.count ?? 0;

  s.atsOpp   = payload.ats?.opp   ?? 0;
  s.atsCount = payload.ats?.count ?? 0;

  s.afBets   = payload.af?.bets   ?? 0;
  s.afRaises = payload.af?.raises ?? 0;
  s.afCalls  = payload.af?.calls  ?? 0;

  s.foldTo3betAllinOpp      = payload.foldTo3betAllin?.opp       ?? 0;
  s.foldTo3betAllinCount    = payload.foldTo3betAllin?.count     ?? 0;
  s.foldTo3betNonAllinOpp   = payload.foldTo3betNonAllin?.opp    ?? 0;
  s.foldTo3betNonAllinCount = payload.foldTo3betNonAllin?.count  ?? 0;

  s.cbetFlopOpp          = payload.cbetFlop?.opp         ?? 0;
  s.cbetFlopCount        = payload.cbetFlop?.count       ?? 0;
  s.cbetFlopSuccessCount = payload.cbetFlopSuccess?.count ?? 0;
  s.cbetTurnOpp          = payload.cbetTurn?.opp         ?? 0;
  s.cbetTurnCount        = payload.cbetTurn?.count       ?? 0;
  s.cbetTurnSuccessCount = payload.cbetTurnSuccess?.count ?? 0;

  s.foldToCbetFlopOpp   = payload.foldToCbetFlop?.opp   ?? 0;
  s.foldToCbetFlopCount = payload.foldToCbetFlop?.count ?? 0;
  s.callCbetFlopCount   = payload.callCbetFlop?.count   ?? 0;
  s.foldToCbetTurnOpp   = payload.foldToCbetTurn?.opp   ?? 0;
  s.foldToCbetTurnCount = payload.foldToCbetTurn?.count ?? 0;
  s.callCbetTurnCount   = payload.callCbetTurn?.count   ?? 0;

  s.donkFlopOpp   = payload.donkFlop?.opp   ?? 0;
  s.donkFlopCount = payload.donkFlop?.count ?? 0;
  s.donkTurnOpp   = payload.donkTurn?.opp   ?? 0;
  s.donkTurnCount = payload.donkTurn?.count ?? 0;
  s.donkRiverOpp   = payload.donkRiver?.opp   ?? 0;
  s.donkRiverCount = payload.donkRiver?.count ?? 0;

  s.probeTurnOpp    = payload.probeTurn?.opp    ?? 0;
  s.probeTurnCount  = payload.probeTurn?.count  ?? 0;
  s.probeRiverOpp   = payload.probeRiver?.opp   ?? 0;
  s.probeRiverCount = payload.probeRiver?.count ?? 0;

  s.flopsSeen = payload.wtsd?.opp   ?? 0;
  s.wtsdCount = payload.wtsd?.count ?? 0;
  s.wwsfOpp   = payload.wwsf?.opp   ?? 0;
  s.wwsfCount = payload.wwsf?.count ?? 0;
  s.wsdOpp    = payload.wsd?.opp    ?? 0;
  s.wsdCount  = payload.wsd?.count  ?? 0;

  if (payload.cbetFlopMatchups)       s.cbetFlopMatchups       = payload.cbetFlopMatchups;
  if (payload.threebetByMatchup)      s.threebetByMatchup      = payload.threebetByMatchup;
  if (payload.foldTo3betByMatchup)    s.foldTo3betByMatchup    = payload.foldTo3betByMatchup;
  if (payload.rfiByPosition)          s.rfiByPosition          = payload.rfiByPosition;
  if (payload.vpipByPosition)         s.vpipByPosition         = payload.vpipByPosition;
  if (payload.cbetFlopByTexture)      s.cbetFlopByTexture      = payload.cbetFlopByTexture;
  if (payload.cbetFlopByTextureMulti) s.cbetFlopByTextureMulti = payload.cbetFlopByTextureMulti;
  if (payload.pushFoldByPosition)     s.pushFoldByPosition     = payload.pushFoldByPosition;

  if (payload.foldToPushByStack) {
    s.foldToPushByShoverStack = payload.foldToPushByStack;
    const bins = Object.values(payload.foldToPushByStack) as Array<{ opp: number; folds: number }>;
    s.foldToPushOpp   = bins.reduce((acc, b) => acc + (b?.opp   ?? 0), 0);
    s.foldToPushCount = bins.reduce((acc, b) => acc + (b?.folds ?? 0), 0);
  }

  if (payload.cbet3betPot) {
    s.cbet3BetPotOpp      = payload.cbet3betPot.opp      ?? 0;
    s.cbet3BetPotCount    = payload.cbet3betPot.count    ?? 0;
    s.cbet3BetPotIPOpp    = payload.cbet3betPot.ipOpp    ?? 0;
    s.cbet3BetPotIPCount  = payload.cbet3betPot.ipCount  ?? 0;
    s.cbet3BetPotOOPOpp   = payload.cbet3betPot.oopOpp   ?? 0;
    s.cbet3BetPotOOPCount = payload.cbet3betPot.oopCount ?? 0;
  }

  return derivedStats(s);
}
